"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _TransportTrace = _interopRequireDefault(require("../components/TransportTrace.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    TransportTrace: _TransportTrace.default
  },
  name: 'OrderDetail',
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      reverse: true,
      // 初始化 reverse 属性
      dialogVisible: false,
      orderDatalist: {
        store: {},
        // 初始化 store 为一个空对象
        platformCarmine: {},
        // 初始化 platformCarmine 为一个空对象
        orderItemList: [],
        // 初始化 orderItemList 为空数组
        orderLogList: [],
        // 初始化 orderLogList 为空数组
        kuaiDiInfoList: [],
        // 初始化 kuaiDiInfoList 为空数组
        orderPay: {},
        // 初始化 orderPay 为空对象
        orderDelivery: {},
        // 初始化 orderDelivery 为空对象
        type: 0 // 初始化订单类型
      },
      loading: false,
      result: [],
      baseOption: [
      // 订单基础信息
      {
        title: '订单编号',
        dataIndex: 'orderNo'
      }, {
        title: '订单状态',
        dataIndex: 'statusName'
      }, {
        title: '物流状态',
        dataIndex: 'deliveryStatusName'
      }, {
        title: '关联售后',
        dataIndex: 'saleAfter'
      }, {
        title: '订单标签',
        dataIndex: 'orderTagStr'
      }, {
        title: '客户备注',
        dataIndex: 'userRemark'
      }, {
        title: '下单人手机号',
        dataIndex: 'userPhone'
      },
      // 新增时间信息
      {
        title: '下单时间',
        dataIndex: 'createTime'
      }, {
        title: '付款时间',
        dataIndex: 'payTime'
      }, {
        title: '发货时间',
        dataIndex: 'shipmentsTime'
      }, {
        title: '完结时间',
        dataIndex: 'endTime'
      }, {
        title: '取消时间',
        dataIndex: 'cancelTime'
      }],
      transportOption: [
      // 物流相关 // orderDelivery
      {
        title: '收货人',
        dataIndex: 'receiverName'
      }, {
        title: '收货电话',
        dataIndex: 'receiverPhone'
      }, {
        title: '收货地址',
        dataIndex: 'receiverAddress'
      }],
      payOption: [{
        title: '支付方式',
        dataIndex: 'payTypeName'
      }],
      priceOption: [
      // 支付明细
      {
        title: '订单总价',
        dataIndex: 'totalPrice',
        widthAll: true
      }, {
        title: '运费',
        dataIndex: 'freight',
        widthAll: true
      }, {
        title: '优惠',
        dataIndex: 'discount',
        isWarning: true,
        widthAll: true,
        uint: '-'
      }, {
        title: '积分抵扣',
        dataIndex: 'useIntegral',
        widthAll: true,
        uint: '-'
      }, {
        title: '卡劵抵扣',
        dataIndex: 'couponPrice',
        isWarning: true,
        widthAll: true,
        uint: '-'
      }, {
        title: '订单实付款',
        dataIndex: 'paidPrice',
        widthAll: true
      }],
      store: [
      // 蛋糕门店信息
      {
        title: '城市名称',
        dataIndex: 'cityName',
        widthAll: false,
        uint: ''
      }, {
        title: '门店名称',
        dataIndex: 'storeName',
        widthAll: false,
        uint: ''
      }, {
        title: '门店电话',
        dataIndex: 'storePhone',
        widthAll: true,
        uint: ''
      }, {
        title: '门店地址',
        dataIndex: 'storeAddr',
        widthAll: true,
        uint: ''
      }],
      thirdPartyCouponInfo: [{
        title: "充值账号",
        dataIndex: "accounts"
      }, {
        title: "供应商订单号",
        dataIndex: "supplierNo"
      }, {
        title: "最后更新时间",
        dataIndex: "updateTime"
      }, {
        title: "三方状态",
        dataIndex: "thirdPartyStatusDesc"
      }],
      diningInfo: [{
        title: "供应商订单编号",
        dataIndex: "supplierNo"
      }, {
        title: "三方状态",
        dataIndex: "thirdPartyStatusDesc"
      }],
      housekeepingInfo: [{
        title: "供应商订单编号",
        dataIndex: "supplierNo"
      }, {
        title: "预约时间",
        dataIndex: "appointmentTime"
      }, {
        title: "上门地址",
        dataIndex: "address"
      }, {
        title: "三方状态",
        dataIndex: "thirdPartyStatusDesc"
      }],
      cakeInfo: [{
        title: "供应商订单编号",
        dataIndex: "supplierNo"
      }, {
        title: "送货时间",
        dataIndex: "deliveryTime"
      }, {
        title: '城市名称',
        dataIndex: 'cityName'
      }, {
        title: '门店名称',
        dataIndex: 'storeName'
      }, {
        title: '门店电话',
        dataIndex: 'storePhone'
      }, {
        title: '门店地址',
        dataIndex: 'storeAddr'
      }, {
        title: "三方状态",
        dataIndex: "thirdPartyStatusDesc"
      }],
      selfOperatedCouponInfo: [{
        title: "卡号",
        dataIndex: "cardNo"
      }, {
        title: "过期时间",
        dataIndex: "dueTime"
      }, {
        title: "卡密",
        dataIndex: "carmine"
      }, {
        title: "关联ID",
        dataIndex: "skuId"
      }, {
        title: "核销码",
        dataIndex: "qrCode"
      }],
      orderNo: null,
      logisticsLoading: false
    };
  },
  mounted: function mounted() {},
  methods: {
    transformState: _transformState.default,
    // 查询详情
    openDetail: function openDetail(orderNo) {
      this.orderNo = orderNo;
      if (!orderNo) {
        this.$message.warning('未查询到该订单！');
        return;
      }
      ;
      this.getOrderData(orderNo);
    },
    // 追踪物流
    openLogistics: function openLogistics(nu) {
      var logisticsInfo = this.orderDatalist.kuaiDiInfoList && this.orderDatalist.kuaiDiInfoList.find(function (info) {
        return info && info.nu === nu;
      });
      if (logisticsInfo) {
        // 确保物流信息中有正确的物流公司名称
        if (!logisticsInfo.deliveryName) {
          logisticsInfo.deliveryName = this.getDeliveryName(logisticsInfo);
        }
        this.$refs['TransportTraceRef'].initOpen([logisticsInfo]);
      } else {
        this.$message.warning('没有物流信息');
      }
    },
    // 路由到售后单详情页面
    navigateToAftersaleDetail: function navigateToAftersaleDetail(aftersaleId) {
      this.$router.push({
        path: "/order/aftersale/aftersaleDetail/".concat(aftersaleId, "/").concat(this.orderNo, "/2")
      });
    },
    // 获取订单物流信息
    getOrderData: function getOrderData(orderNo) {
      var _this = this;
      this.dialogVisible = true;
      this.loading = true;
      orderListApi.getOrderDetail(orderNo).then(function (res) {
        try {
          console.log("API Response:", JSON.stringify(res));
          if (!res) {
            throw new Error('获取订单详情失败');
          }
          console.log("Order type:", res.type);

          // 先创建一个完整的数据结构，确保所有属性都有默认值
          var defaultData = {
            orderDelivery: {},
            orderPay: {},
            orderItemList: [],
            kuaiDiInfoList: [],
            orderLogList: [],
            platformCarmine: {},
            storeDetail: {},
            type: res.type || 0,
            status: res.status || '',
            statusName: res.statusName || '',
            tagName: '',
            tagRemark: '',
            orderTagStr: '',
            dynamicFormInfo: null
          };

          // 将API返回的数据合并到默认数据中
          var mergedData = _objectSpread(_objectSpread({}, defaultData), res);

          // 特殊处理自营卡券订单
          if (mergedData.type === 12) {
            console.log("Processing type 12 order");
            mergedData.platformCarmine = mergedData.platformCarmine || {};
          }

          // 处理表单数据
          if (mergedData.dynamicFormInfo) {
            console.log("处理表单数据:", mergedData.dynamicFormInfo);

            // 确保formItems存在
            if (!mergedData.dynamicFormInfo.formItems) {
              mergedData.dynamicFormInfo.formItems = [];

              // 从content中解析表单项定义
              if (mergedData.dynamicFormInfo.content) {
                try {
                  var formDefinitions = JSON.parse(mergedData.dynamicFormInfo.content);
                  console.log("表单定义:", formDefinitions);

                  // 获取表单提交的数据
                  var formData = [];
                  if (mergedData.dynamicFormInfo.data && Array.isArray(mergedData.dynamicFormInfo.data)) {
                    // 如果data是数组，直接使用
                    formData = mergedData.dynamicFormInfo.data;
                  } else if (typeof mergedData.dynamicFormInfo.data === 'string') {
                    // 如果data是字符串，尝试解析为JSON
                    try {
                      formData = JSON.parse(mergedData.dynamicFormInfo.data);
                    } catch (e) {
                      console.error("解析data字段失败:", e);
                    }
                  }
                  console.log("解析后的表单数据:", formData);

                  // 将表单定义和数据合并
                  formDefinitions.forEach(function (def) {
                    // 查找对应的数据项
                    var dataItem = Array.isArray(formData) ? formData.find(function (d) {
                      return d && d.itemKey === def.itemKey;
                    }) : null;

                    // 处理表单值
                    var formValue = dataItem ? dataItem.value : def.defaultValue || '';

                    // 针对多选框类型，确保值是JSON字符串数组格式
                    if (def.type === 'checkbox' && formValue) {
                      // 检查是否已经是JSON字符串
                      if (!formValue.startsWith('[')) {
                        try {
                          // 可能是逗号分隔的值，尝试转换为数组再转为JSON
                          var valueArray = formValue.split(',').map(function (v) {
                            return v.trim();
                          }).filter(Boolean);
                          formValue = JSON.stringify(valueArray);
                        } catch (e) {
                          console.error("处理checkbox值失败:", e);
                        }
                      }
                    }

                    // 处理单选框和下拉框选项
                    var formOptions = null;
                    if (def.options) {
                      formOptions = def.options.map(function (opt) {
                        return {
                          name: opt.name || '',
                          value: opt.name || ''
                        };
                      }).filter(function (opt) {
                        return opt.name;
                      });
                    }

                    // 添加到表单项列表
                    mergedData.dynamicFormInfo.formItems.push({
                      title: def.formTitle || '未命名',
                      key: def.itemKey,
                      type: def.type,
                      required: def.isRequired === 1,
                      value: formValue,
                      options: formOptions,
                      placeholder: def.placeholder || '',
                      valueId: dataItem ? dataItem.valueId : null // 添加 valueId
                    });
                  });
                } catch (e) {
                  console.error("解析表单内容失败:", e);
                }
              }
            } else {
              // 如果已有formItems，确保处理多选框值的格式
              mergedData.dynamicFormInfo.formItems.forEach(function (item) {
                if (item.type === 'checkbox' && item.value && !item.value.startsWith('[')) {
                  try {
                    var valueArray = item.value.split(',').map(function (v) {
                      return v.trim();
                    }).filter(Boolean);
                    item.value = JSON.stringify(valueArray);
                  } catch (e) {
                    console.error("处理已有checkbox值失败:", e);
                  }
                }
              });
            }
            console.log("处理后的表单项:", mergedData.dynamicFormInfo.formItems);
          }

          // 处理kuaiDiInfoList，为每个物流信息添加物流公司名称
          if (mergedData.kuaiDiInfoList && mergedData.kuaiDiInfoList.length > 0) {
            var companyMap = {
              'shentong': '申通快递',
              'ems': 'EMS快递',
              'youzhengguonei': '邮政快递',
              'yuantong': '圆通快递',
              'shunfeng': '顺丰快递',
              'yunda': '韵达快递',
              'zhongtong': '中通快递',
              'jd': '京东物流',
              'tiantian': '天天快递',
              'debangwuliu': '德邦物流',
              'huitongkuaidi': '百世快递'
            };

            // 处理物流信息
            mergedData.kuaiDiInfoList.forEach(function (item) {
              if (item && !item.deliveryName) {
                // 尝试从orderDelivery中获取快递公司名称
                if (mergedData.orderDelivery && mergedData.orderDelivery.orderDeliveryList && mergedData.orderDelivery.orderDeliveryList.length > 0) {
                  var matchedDelivery = mergedData.orderDelivery.orderDeliveryList.find(function (delivery) {
                    return delivery.deliveryNo === item.nu;
                  });
                  if (matchedDelivery && matchedDelivery.deliveryCompany) {
                    item.deliveryName = matchedDelivery.deliveryCompany;
                  } else if (item.com && companyMap[item.com]) {
                    item.deliveryName = companyMap[item.com];
                  } else {
                    item.deliveryName = '未知物流公司';
                  }
                } else if (item.com && companyMap[item.com]) {
                  item.deliveryName = companyMap[item.com];
                } else {
                  item.deliveryName = '未知物流公司';
                }
              }
            });
          }

          // 处理orderItemList，确保aftersaleAndAmount属性存在
          if (Array.isArray(mergedData.orderItemList)) {
            mergedData.orderItemList = mergedData.orderItemList.map(function (item) {
              if (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  aftersaleAndAmount: item.aftersaleAndAmount || []
                });
              }
              return null;
            }).filter(Boolean);
          }

          // 确保orderDelivery有值
          mergedData.orderDelivery = mergedData.orderDelivery || {};

          // 确保orderPay有值
          mergedData.orderPay = mergedData.orderPay || {};

          // 添加orderTagStr属性
          mergedData.orderTagStr = "".concat(mergedData.tagName || '', "-").concat(mergedData.tagRemark || '');
          console.log("Final processed data:", JSON.stringify(mergedData));

          // 更新组件状态
          _this.orderDatalist = mergedData;
        } catch (error) {
          console.error('Error processing order details:', error);
          _this.$message.error('处理订单详情数据出错: ' + (error.message || '未知错误'));
        } finally {
          _this.loading = false;
        }
      }).catch(function (err) {
        console.error('Error loading order details:', err);
        _this.loading = false;
        _this.$message.error('获取订单详情失败: ' + (err.message || '未知错误'));
      });
    },
    // 获取表单字段类型名称
    getFormItemTypeName: function getFormItemTypeName(type) {
      var typeMap = {
        'input': '单行文本',
        'textarea': '多行文本',
        'select': '下拉选择',
        'radio': '单选按钮',
        'checkbox': '多选按钮',
        'dateSelect': '日期',
        'phone': '电话号码',
        'tips': '说明文本'
      };
      return typeMap[type] || type;
    },
    // 获取表单字段类型标签颜色
    getFormItemTagType: function getFormItemTagType(type) {
      var typeTagMap = {
        'input': '',
        'textarea': 'info',
        'select': 'warning',
        'radio': 'success',
        'checkbox': 'primary',
        'dateSelect': 'warning',
        'phone': 'danger',
        'tips': 'info'
      };
      return typeTagMap[type] || '';
    },
    getDeliveryName: function getDeliveryName(logisticsInfo) {
      // 首先尝试使用 logisticsInfo 中的 deliveryName
      if (logisticsInfo.deliveryName) {
        return logisticsInfo.deliveryName;
      }

      // 如果没有，尝试从 orderDelivery 中获取对应的快递公司名称
      if (this.orderDatalist && this.orderDatalist.orderDelivery && this.orderDatalist.orderDelivery.orderDeliveryList && this.orderDatalist.orderDelivery.orderDeliveryList.length > 0) {
        // 尝试匹配物流单号
        var delivery = this.orderDatalist.orderDelivery.orderDeliveryList.find(function (item) {
          return item.deliveryNo === logisticsInfo.nu;
        });
        if (delivery && delivery.deliveryCompany) {
          return delivery.deliveryCompany;
        }
      }

      // 最后尝试使用快递公司编码映射到名称
      var companyMap = {
        'shentong': '申通快递',
        'ems': 'EMS快递',
        'youzhengguonei': '邮政快递',
        'yuantong': '圆通快递',
        'shunfeng': '顺丰快递',
        'yunda': '韵达快递',
        'zhongtong': '中通快递',
        'jd': '京东物流',
        'tiantian': '天天快递',
        'debangwuliu': '德邦物流',
        'huitongkuaidi': '百世快递'
      };
      if (logisticsInfo.com && companyMap[logisticsInfo.com]) {
        return companyMap[logisticsInfo.com];
      }

      // 如果都没有找到，返回默认值
      return '未知物流公司';
    },
    // 格式化表单值
    formatFormValue: function formatFormValue(item) {
      if (!item.value) {
        return '--';
      }
      if (item.type === 'checkbox') {
        try {
          var parsedValue = JSON.parse(item.value);
          if (Array.isArray(parsedValue) && parsedValue.length > 0) {
            return parsedValue.join(', ');
          }
        } catch (e) {
          console.error("Error parsing checkbox value:", e);
        }
      }
      return item.value;
    },
    // 解析表单值为数组
    parseFormValue: function parseFormValue(value) {
      if (!value) return [];
      try {
        var parsedValue = JSON.parse(value);
        if (Array.isArray(parsedValue)) {
          return parsedValue.map(function (val) {
            if (typeof val === 'string') {
              return val.trim();
            }
            return val;
          }).filter(Boolean);
        }
      } catch (e) {
        console.error("Error parsing form value:", e);
      }
      return [];
    },
    // 格式化电话号码
    formatPhoneNumber: function formatPhoneNumber(value) {
      if (!value) return '--';
      // 假设电话号码格式为 XXX-XXXX-XXXX 或 XXX-XXXX-XXXXX
      var cleaned = value.replace(/\D/g, '');
      if (cleaned.length === 11) {
        return "".concat(cleaned.substring(0, 3), "-").concat(cleaned.substring(3, 7), "-").concat(cleaned.substring(7));
      } else if (cleaned.length === 10) {
        return "".concat(cleaned.substring(0, 3), "-").concat(cleaned.substring(3, 6), "-").concat(cleaned.substring(6));
      } else {
        return value; // 保留原始值
      }
    },
    // 复制表单数据
    copyFormData: function copyFormData(formData) {
      var _this2 = this;
      if (!formData || !formData.formItems || formData.formItems.length === 0) {
        this.$message.warning('没有可复制的表单数据');
        return;
      }

      // 将表单数据格式化为易读格式
      var formattedData = "\u8868\u5355\u6807\u9898: ".concat(formData.title || '无标题', "\n");
      formattedData += "\u63D0\u4EA4\u65F6\u95F4: ".concat(formData.submitTime || '未知', "\n\n");
      formattedData += "\u8868\u5355\u5185\u5BB9:\n";
      formData.formItems.forEach(function (item, index) {
        formattedData += "".concat(index + 1, ". ").concat(item.title || '未命名', ": ");
        if (item.type === 'checkbox' && item.value && item.value.startsWith('[')) {
          try {
            var values = JSON.parse(item.value);
            if (Array.isArray(values) && values.length > 0) {
              formattedData += values.join(', ');
            } else {
              formattedData += '无数据';
            }
          } catch (e) {
            formattedData += item.value || '无数据';
          }
        } else if (item.type === 'tips') {
          formattedData += "(\u8BF4\u660E\u6587\u5B57) ".concat(item.value || item.placeholder || '');
        } else {
          formattedData += item.value || '无数据';
        }
        formattedData += " (".concat(_this2.getFormItemTypeName(item.type)).concat(item.required ? ', 必填' : '', ")\n");
      });

      // 创建一个临时的textarea元素
      var textarea = document.createElement('textarea');
      textarea.value = formattedData;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);

      // 选择文本并执行复制命令
      textarea.select();
      var success = false;
      try {
        success = document.execCommand('copy');
        if (success) {
          this.$message.success('表单数据已复制到剪贴板！');
        } else {
          this.$message.error('复制失败，请手动复制');
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$message.error('复制失败: ' + (err.message || '未知错误'));
      }

      // 移除临时元素
      document.body.removeChild(textarea);
    }
  }
};